import React, { useState, useRef,useEffect } from 'react';
import { saveFile } from "./SaveIndexDb";
import { playAudioWithProcessing } from "./FrontPlayAudio"
import {encodeWav} from "./FrontEncodeWav"
import NowLoading from './ModalLoading';

const FileDropzone = ({ files, setFiles, eqValues, params}) => {
    const [dragging, setDragging] = useState(false);
    const fileInputRef = useRef(null);
    const tracksRef = useRef([]);
    const [loading, setLoading] = useState(false);
    const [dirmode, setDirmode] = useState(false);
    const [result, setResult] = useState(null);
    const [playing, setPlaying] = useState(false);
    const [btAnime, setBtAnime] = useState(false);
    const AUDIO_EXTENSIONS = [
        '.wav', '.mp3', '.flac', '.aac', '.ogg', '.m4a', '.zip'
    ];

    const workerRef = useRef(null);
    const audioCtxRef = useRef(null);
    const eqNodesRef = useRef([]);
    

    // ✅ AudioContextは1つだけ
    useEffect(() => {
        audioCtxRef.current = new AudioContext();

        return () => {
            audioCtxRef.current.close();
        };
    }, []);
    
    
    

    // useEffect(() => {
    //     if (!eqNodesRef.current.length) return;
    //     if (!audioCtxRef.current) return;

    //     const t = audioCtxRef.current.currentTime;

    //     eqValues.forEach((v, i) => {
    //         const node = eqNodesRef.current[i];
    //         if (!node) return;

    //         // 🔥 スムーズ変更（超重要）
    //         node.gain.setTargetAtTime(
    //             Math.max(-12, Math.min(12, v * 10)),
    //             t,
    //             0.01
    //         );
    //     });

    // }, [eqValues]);
    // ✅ 再生（全トラック）
    const playingCountRef = useRef(0);
    const handlePlay = async () => {
        if (tracksRef.current.length === 0) return;

        setPlaying(true);
        setLoading(true);
        eqNodesRef.current = []; // ←重要（リセット）
        playingCountRef.current = tracksRef.current.length;
        let maxDuration = 0;
        
        tracksRef.current.forEach((track) => {
            const duration = track.left.length / track.sampleRate;
            maxDuration = Math.max(maxDuration, duration);
            
            playAudioWithProcessing(
                track,
                {},
                eqNodesRef,
                audioCtxRef,
                params, 
                () => {
                    playingCountRef.current -= 1;

                    if (playingCountRef.current === 0) {
                        setPlaying(false); // ← 全部終わったら
                        setLoading(false);
                    }
                }
            );
        });
        setTimeout(() => {
            console.warn("force stop");
            setPlaying(false);
            setLoading(false);
            playingCountRef.current = 0;
        }, maxDuration * 1000 + 500);
        
    };
    // ✅ EQリアルタイム反映
    useEffect(() => {
        if (!audioCtxRef.current) return;

        const t = audioCtxRef.current.currentTime;

        eqNodesRef.current.forEach((trackEQ) => {
            trackEQ.forEach((node, i) => {
                const v = eqValues[i] || 0;

                node.gain.setTargetAtTime(
                    Math.max(-12, Math.min(12, v * 20)),
                    t,
                    0.01
                );
            });
        });

    }, [eqValues]);
    
    // ✅ ファイル読み込み
    const handleFile = async (file) => {
        setLoading(true);

        const arrayBuffer = await file.arrayBuffer();

        const ctx = new AudioContext();
        const audioBuffer = await ctx.decodeAudioData(arrayBuffer);
        ctx.close();

        const sampleRate = audioBuffer.sampleRate;
        
        const duration = audioBuffer.duration;
        // 10秒分切り出し
        const T = sampleRate * 10;

        // ★ 15秒未満なら0秒、それ以上なら15秒
        const startSec = duration < 15 ? 0 : 15;
        const startSampleIndex = Math.floor(sampleRate * startSec);
        const endSampleIndex = Math.min(startSampleIndex + T, audioBuffer.length);
        
        // 左右とも同じ範囲で切り出す
        const left = audioBuffer
            .getChannelData(0)
            .slice(startSampleIndex, endSampleIndex);

        const right = audioBuffer.numberOfChannels > 1
            ? audioBuffer
                .getChannelData(1)
                .slice(startSampleIndex, endSampleIndex)
            : new Float32Array(left);

        const track = {
            left: new Float32Array(left),
            right: new Float32Array(right),
            sampleRate
        };

        tracksRef.current.push(track);
        setLoading(false);
        setPlaying(false);
        setBtAnime(true);
        
    };
    
    // Worker初期化
    useEffect(() => {
        workerRef.current = new Worker(
            new URL("./worker.js", import.meta.url),
            { type: "module" }
        );

        workerRef.current.onmessage = (e) => {
            setLoading(false); // 推論終了
            
            if (!e.data.error) {
                setResult(e.data);
                // // 再生
                // if (window._lastAudioData) {
                //     const { left, right, sampleRate } = window._lastAudioData;
                //     playAudioWithProcessing(left, right, sampleRate, e.data);
                // }
            } else {
                console.error("Worker error:", e.data.error);
            }
        };

        return () => workerRef.current.terminate();
    }, []);
    
    
    const isAudioFile = (file) => {
        const ext = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
        return file.type.startsWith('audio/') || AUDIO_EXTENSIONS.includes(ext);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragging(false);
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        setDragging(false);

        if (e.dataTransfer.items) {
            const items = Array.from(e.dataTransfer.items);
            const fileList = [];
            const filePromises = [];

            for (const item of items) {
                if (item.kind === 'file') {
                    const file = item.getAsFile();
                    if (file && isAudioFile(file)) {
                        fileList.push(file);
                        filePromises.push(saveFile(file).then(() => handleFile(file)));
                    }
                }
            }

            // 全てのファイル処理が終わるまで待機
            await Promise.all(filePromises);

            setFiles(fileList);
        }
    };

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const fileList = Array.from(e.target.files);
            setFiles(fileList);   // ← 親state更新
            // ① IndexedDB保存
            for (const file of fileList) {
                if (file && isAudioFile(file)) {
                    await saveFile(file);
                    await handleFile(file);
                }
             
                
            }
        }
    };

    const modeChange = () => {
        setDirmode(!dirmode);
    };
    
    useEffect(() => {
        const style = document.createElement("style");
        style.textContent = `
            @keyframes pulse {
                0% { transform: scale(1); }
                50% { transform: scale(1.3); }
                100% { transform: scale(1); }
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);
    
    return (
        <div
            className="drop_area"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}
        >
            {dirmode ? (
                <>
                    <div
                        style={{
                            border: dragging ? '2px dashed #00f' : '2px solid #ccc',
                            padding: '30px',
                            width: 'auto',
                            height: '200px',
                            textAlign: 'center',
                            margin: '20px',
                            cursor: 'pointer',
                            backgroundColor: '#ebebebff',
                            overflowY: 'auto',
                            borderRadius: '15px',
                            boxShadow: `
                                -4px -4px 8px rgba(255, 255, 255, 0.9),
                                6px  6px 12px rgba(0, 0, 0, 0.2)
                            `,
                        }}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleClick}
                    >
                        {files.length > 0 ? (
                            files.map((file, index) => (
                                <div className="in_file_name" key={index}>
                                    {file.webkitRelativePath || file.name}
                                </div>
                            ))
                        ) : (
                            'Click here to select a directory'
                        )}

                        <input
                            type="file"
                            accept="audio/*,.wav,.mp3,.flac,.aac,.ogg,.m4a,.zip"
                            directory=""
                            webkitdirectory=""
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            multiple
                        />
                    </div>
                </>
            ) : (
                <>
                    <div
                        style={{
                            border: dragging ? '2px dashed #00f' : '2px solid #ccc',
                            padding: '30px',
                            width: 'auto',
                            height: '200px',
                            textAlign: 'center',
                            margin: '20px',
                            cursor: 'pointer',
                            backgroundColor: '#ebebebff',
                            overflowY: 'auto',
                            borderRadius: '15px',
                            boxShadow: `
                                -4px -4px 8px rgba(255, 255, 255, 0.9),
                                6px  6px 12px rgba(0, 0, 0, 0.2)
                            `,
                        }}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleClick}
                    >
                        {files.length > 0 ? (
                            files.map((file, index) => (
                                <div className="in_file_name" key={index}>
                                    {file.webkitRelativePath || file.name}
                                </div>
                            ))
                        ) : (
                            'Drag & drop files here'
                        )}

                        <input
                                type="file"
                                accept="audio/*,.wav,.mp3,.flac,.aac,.ogg,.m4a,.zip"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            multiple
                        />
                    </div>
                </>
            )}
            {loading && <NowLoading/>}
            {/* <pre>{JSON.stringify(result, null, 2)}</pre> */}
            <div>
               
                {playing ?
                    
                    <span style={{ marginLeft: 10, color: "green" }}>🎵 再生中...</span>
                    :
                    <button
                        style={{
                            padding: '10px',
                            color: 'white',
                            display: btAnime ? 'block' : 'none',
                            backgroundColor:  '#6c56ff', 
                            borderRadius: '50px',
                            animation: btAnime ? "pulse 1s infinite" : "none"
                        }}
                        onClick={handlePlay}
                        disabled={tracksRef.current.length === 0}
                    >
                        PreviewPlay</button>
                }
            </div>
            {/* <button
                style={{
                    padding: '10px',
                    color: 'white',
                    backgroundColor: '#ff56aa',
                    borderRadius: '50px'
                }}
                onClick={modeChange}
            >
                {dirmode ? 'FileMode' : 'DirMode'}
            </button> */}
        </div>
    );
};

export default FileDropzone;


// const handleDrop = (e) => {
//     e.preventDefault();
//     setDragging(false);

//     if (e.dataTransfer.items) {
//         const items = Array.from(e.dataTransfer.items);
//         const fileList = [];

//         items.forEach((item) => {
//             if (item.kind === 'file') {
//                 const file = item.getAsFile();
//                 if (file && isAudioFile(file)) {
//                     fileList.push(file);
//                 }
//             }
//         });

//         setFiles(fileList);   // ← 親state更新
//     }
// };

// const handleFileChange = (e) => {
//     if (e.target.files && e.target.files.length > 0) {
//         const fileList = Array.from(e.target.files);
//         setFiles(fileList);   // ← 親state更新
//     }
// };